import SyntheseModeleFormController from './synthesemodeles.form.controller';

export default {
    template: require('./synthesemodeles.form.html'),
    controller: SyntheseModeleFormController
};
